export default "/images/vendor/flag-icons/flags/4x3/nu.svg?2d9c15c308eff50f974fa2c3939ac8c9";